import script from "./Tiers.vue?vue&type=script&setup=true&lang=js"
export * from "./Tiers.vue?vue&type=script&setup=true&lang=js"

import "./Tiers.vue?vue&type=style&index=0&id=546905a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-546905a6"]])

export default __exports__